export const cities = ["Москва", "Санкт-Петербург"];
